import ContextProvider from 'common/contexts/crud';
import React, { createContext, useContext } from 'react';

const TaskTypesContext = createContext();
const useTaskTypes = () => useContext(TaskTypesContext);

export const TaskTypesProvider = (props) => <ContextProvider url="task-types" context={TaskTypesContext} {...props} />;

export default useTaskTypes;
